import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { OnboardingOverlay } from "../onboarding/OnboardingOverlay";

export function AppLayout() {
  return (
    <div className="h-screen flex flex-col bg-gray-50">
      <OnboardingOverlay />
      <Header />
      <div className="flex-1 flex overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-auto p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
